import React from 'react';
import styles from './FormLabel.module.css';
import { Tooltip } from '../layout/Tooltip';

type FormLabelProps = {
    children: React.ReactNode;
    htmlFor?: string;
    required?: boolean;
    tooltipText?: string;
    tooltipPosition?: 'left' | 'right';
};

const FormLabel: React.FC<FormLabelProps> = ({
    children,
    htmlFor,
    required = false,
    tooltipText,
    tooltipPosition = 'right',
}) => {
    return (
        <label htmlFor={htmlFor} className={styles.label} title={tooltipText}>
            {children}
            {required && <span className={styles.required}>*</span>}
        </label>
    );
};

export default FormLabel;
